import { render, staticRenderFns } from "./AreaCode.vue?vue&type=template&id=65ff1852&lang=pug&"
import script from "./AreaCode.vue?vue&type=script&lang=ts&"
export * from "./AreaCode.vue?vue&type=script&lang=ts&"
import style0 from "./AreaCode.vue?vue&type=style&index=0&id=65ff1852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports